export const lapaz = {
	nombre: "La Paz",
	dia: "Domingo de Ramos",
	nombrecompleto:
		"Venerable Cofradía Carmelitana de Penitencia y Hermandad Sacramental de Nazarenos de Nuestro Padre Jesús de la Paz en su Real y Triunfal Entrada en Jerusalén y Nuestra Madre y Señora María Santísima del Amparo",
	sede: "Iglesia de San José (Extramuros)",
	pasos: 2,
	distancia: [2770, 3720],
	penitentes: 280,
	cargadores: 120,
	web: "http://www.diariodecadiz.es/semana_santa/Borriquita_0_1229277784.html",
	ida: [
		{ lng: -6.280705, lat: 36.5139273 },
		{ lng: -6.2807196, lat: 36.513965 },
		{ lng: -6.2812453, lat: 36.5137882 },
		{ lng: -6.2875753, lat: 36.5250101 },
		{ lng: -6.2878221, lat: 36.5256222 },
		{ lng: -6.2885302, lat: 36.5263637 },
		{ lng: -6.2889379, lat: 36.526812 },
		{ lng: -6.2888842, lat: 36.5271741 },
		{ lng: -6.2887662, lat: 36.5275103 },
		{ lng: -6.2888601, lat: 36.5277668 },
		{ lng: -6.2895635, lat: 36.5286817 },
		{ lng: -6.2906746, lat: 36.5293122 },
		{ lng: -6.292239, lat: 36.53024 },
		{ lng: -6.2919671, lat: 36.5304647 },
		{ lng: -6.2926519, lat: 36.5312366 },
		{ lng: -6.2929273, lat: 36.5310815 },
		{ lng: -6.2922358, lat: 36.5303375 },
		{ lng: -6.2924828, lat: 36.5300905 },
		{ lng: -6.2928129, lat: 36.5297924 },
		{ lng: -6.2930785, lat: 36.5298029 },
		{ lng: -6.2933152, lat: 36.5297333 },
		{ lng: -6.293568, lat: 36.5297068 },
		{ lng: -6.2945397, lat: 36.5296318 },
		{ lng: -6.2945963, lat: 36.5295609 },
		{ lng: -6.2950847, lat: 36.5294964 },
		{ lng: -6.29535, lat: 36.52899 }
	],
	vuelta: [
		{ lng: -6.29535, lat: 36.52899 },
		{ lng: -6.2955844, lat: 36.529088 },
		{ lng: -6.2956917, lat: 36.5291225 },
		{ lng: -6.2954235, lat: 36.529767 },
		{ lng: -6.295673, lat: 36.5299545 },
		{ lng: -6.2952848, lat: 36.5303552 },
		{ lng: -6.2950292, lat: 36.530823 },
		{ lng: -6.2949353, lat: 36.5308403 },
		{ lng: -6.2949461, lat: 36.5314632 },
		{ lng: -6.2964427, lat: 36.531767 },
		{ lng: -6.296424, lat: 36.5318597 },
		{ lng: -6.2967847, lat: 36.5325418 },
		{ lng: -6.2965795, lat: 36.532766 },
		{ lng: -6.2958292, lat: 36.5324352 },
		{ lng: -6.2949273, lat: 36.5333748 },
		{ lng: -6.2921566, lat: 36.5302788 },
		{ lng: -6.2915786, lat: 36.5299049 },
		{ lng: -6.28952, lat: 36.5286926 },
		{ lng: -6.2888253, lat: 36.5278035 },
		{ lng: -6.2887073, lat: 36.527519 },
		{ lng: -6.2888253, lat: 36.5271483 },
		{ lng: -6.2888736, lat: 36.5268293 },
		{ lng: -6.2877524, lat: 36.5256438 },
		{ lng: -6.28746, lat: 36.5253658 },
		{ lng: -6.2870899, lat: 36.5256718 },
		{ lng: -6.2866715, lat: 36.5253161 },
		{ lng: -6.2858319, lat: 36.5237308 },
		{ lng: -6.2850541, lat: 36.5232534 },
		{ lng: -6.2840671, lat: 36.5219214 },
		{ lng: -6.2826347, lat: 36.5199835 },
		{ lng: -6.2806392, lat: 36.5181728 },
		{ lng: -6.2802154, lat: 36.5178279 },
		{ lng: -6.2799579, lat: 36.5175348 },
		{ lng: -6.2792981, lat: 36.5165863 },
		{ lng: -6.2790346, lat: 36.5160318 },
		{ lng: -6.2788676, lat: 36.5154772 },
		{ lng: -6.2785859, lat: 36.5143886 },
		{ lng: -6.2801302, lat: 36.514492 },
		{ lng: -6.2801832, lat: 36.5139908 },
		{ lng: -6.2804541, lat: 36.5140361 },
		{ lng: -6.2806875, lat: 36.5139779 },
		{ lng: -6.280666, lat: 36.5139391 },
		{ lng: -6.280705, lat: 36.5139273 }
	],
	markers: [
		{
			name: "Salida",
			hora: "2018-03-25T13:30",
			latlng: [36.51382, -6.28067]
		},
		{
			name: "Nueva",
			hora: "2018-03-25T16:50",
			latlng: [36.53062, -6.29249]
		},
		{
			name: "Catedral",
			hora: "2018-03-25T17:50",
			latlng: [36.52899, -6.29535]
		},
		{
			name: "Candelaria",
			hora: "2018-03-25T18:50",
			latlng: [36.53106, -6.295]
		},
		{
			name: "Palillero",
			hora: "2018-03-25T19:15",
			latlng: [36.53196, -6.2965]
		},
		{
			name: "Valverde, Barrié",
			hora: "2018-03-25T19:25",
			latlng: [36.53266, -6.29667]
		}
	],
	itinerario: [
		[
			"Avda. Ana de Viya",
			"Avda. Andalucía",
			"Plaza Constitución",
			"Cuesta de las Calesas",
			"Plocia",
			"Plaza San Juan de Dios",
			"Avda. 4 de Diciembre de 1977",
			"Cristobal Colón",
			"Nueva"
		],
		[
			"Plaza San Juan de Dios",
			"Pelota",
			"Plaza Pio XII",
			"Estación de Penitencia en la S.I.C."
		],
		[
			"Arquitecto Acero",
			"Plaza de Pio XII",
			"Compañía",
			"Santiago",
			"Plaza Candelaria"
		],
		["Montañés", "Palillero"],
		["Novena"],
		[
			"Valverde",
			"José del Toro (dcha.)",
			"Columela (izq.)",
			"San Francisco",
			"Plaza San Agustín",
			"San Francisco",
			"Nueva",
			"Plaza San Juan de Dios",
			"Plocia",
			"Cuesta de las Calesas",
			"Plaza de la Constitución",
			"Acacias",
			"Brunete",
			"Avda. de San Francisco",
			"García de Sola",
			"Avda. Portugal",
			"Adriano",
			"Poeta Nieto",
			"Avda. Ana de Viya",
			"A su templo"
		]
	],
	mapConfig: {
		center: [36.52979, -6.29573],
		zoom: 17
	}
};



// WEBPACK FOOTER //
// ./src/data/procesiones/lapaz.js